import React from 'react';
import { IconSort } from '../icons/generated';
import { Stack } from '../stack';
import { semantic_colors } from '../../foundation';
import { SortDirection } from './types';

export interface TableSortIndicatorProps {
  isSorted: boolean;
  sortDirection: SortDirection;
}

export const TableSortIndicator = ({ isSorted, sortDirection }: TableSortIndicatorProps) => {
  return (
    <Stack direction='column' align='center'>
      <IconSort
        color={
          isSorted
            ? sortDirection === 'asc'
              ? semantic_colors.accent.primary
              : semantic_colors.content.tertiary
            : semantic_colors.content.tertiary
        }
        secondaryColor={
          isSorted
            ? sortDirection === 'asc'
              ? semantic_colors.content.tertiary
              : semantic_colors.accent.primary
            : semantic_colors.content.tertiary
        }
      />
    </Stack>
  );
};
